import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    config: MatSnackBarConfig = { duration: 3500, verticalPosition: 'bottom', horizontalPosition: 'right' };

    constructor(public snackBar: MatSnackBar) {}



    success(msg: string) {
        this.config['panelClass'] = ['notification', 'alert-success'];
        this.snackBar.open(msg, '', this.config);
    }



    error(msg: string) {
        this.config['panelClass'] = ['notification', 'alert-danger'];
        const errorConfig: MatSnackBarConfig = { duration: 5000, verticalPosition: 'bottom', horizontalPosition: 'right' };
        this.snackBar.open(msg, 'Error', errorConfig);
    }



}
